require("./bootstrap");
require("./vue");
// require("./assinatura");

const hamburger = document.querySelector('.hamburger-menu');
const navMenu = document.querySelector('.nav-mobile-menu');
const navLink = document.querySelectorAll('.nav-mobile-link');

if(hamburger)
    hamburger.addEventListener('click', mobileMenu);
if(navLink)
    navLink.forEach(n => n.addEventListener('click', closeMenu));

function mobileMenu() {
    if(hamburger)
        hamburger.classList.toggle('active');
    if(navMenu)
        navMenu.classList.toggle('active');
}

function closeMenu() {
    if(hamburger)
        hamburger.classList.remove('active');
    if(navMenu)
        navMenu.classList.remove('active');
}
